import { useState, useRef, useEffect } from 'react';
export const useGuestInfo = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState({
    code: '+1',
    flag: 'https://flagcdn.com/w40/us.png',
    name: 'United States',
  });
  const [showDropdown, setShowDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const dropdownRef = useRef(null);

  const countries = [
    {
      code: '+1',
      flag: 'https://flagcdn.com/w40/us.png',
      name: 'United States',
    },
    { code: '+52', flag: 'https://flagcdn.com/w40/mx.png', name: 'Mexico' },
    { code: '+34', flag: 'https://flagcdn.com/w40/es.png', name: 'Spain' },
    { code: '+51', flag: 'https://flagcdn.com/w40/pe.png', name: 'Peru' },
    { code: '+54', flag: 'https://flagcdn.com/w40/ar.png', name: 'Argentina' },
    { code: '+55', flag: 'https://flagcdn.com/w40/br.png', name: 'Brazil' },
  ];

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSubmit = async (values, onGuestInfo) => {
    setLoading(true);
    setError(null);
    try {
      await onGuestInfo(values);
    } catch (err) {
      setError('Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCountrySelect = country => {
    setSelectedCountry(country);
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(prev => !prev);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return {
    loading,
    error,
    handleSubmit,
    selectedCountry,
    showDropdown,
    dropdownRef,
    countries,
    handleCountrySelect,
    toggleDropdown,
    showModal,
    openModal,
    closeModal,
  };
};
